import { Injectable } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth'
import {AngularFirestore} from '@angular/fire/firestore'
import { Router } from '@angular/router';
import { Usuarios } from '../interfaces/users.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthenService {

  constructor(private auth:AngularFireAuth,private db:AngularFirestore,private router:Router) { }

  async authentificathion(correo:string,contrasena:string){
   
      this.auth.signInWithEmailAndPassword(correo,contrasena).then(x=>{
        console.log(x.user.uid)
        this.db.collection('usuarios').doc(x.user.uid).snapshotChanges().subscribe(k=>{
          const data=k.payload.data() as Usuarios
          if(data.estado==0){
            this.router.navigateByUrl('/principal')
          }else{
            this.logouthin()
          }
        })
         
                                                              
      }).catch(e=>{
        alert(e)
      })
    
  }

  async logouthin(){
     this.auth.signOut().then(()=>{
      this.router.navigate(['/'])
     })
  }
}
